import { M as ListStyleType, b as someTodoList, o as toggleList, t as BaseListPlugin, x as someList } from "../src-Dvsp2AeZ.js";
import { c } from "react-compiler-runtime";
import { toPlatePlugin, useEditorRef, useEditorSelector, useReadOnly } from "platejs/react";

//#region src/react/ListPlugin.tsx
/** Enables support for indented lists with React-specific features. */
const ListPlugin = toPlatePlugin(BaseListPlugin);

//#endregion
//#region src/react/hooks/useListToolbarButton.ts
const useListToolbarButtonState = (t0) => {
	const $ = c(8);
	let t1;
	if ($[0] !== t0) {
		t1 = t0 === void 0 ? {} : t0;
		$[0] = t0;
		$[1] = t1;
	} else t1 = $[1];
	const { nodeType: t2 } = t1;
	const nodeType = t2 === void 0 ? ListStyleType.Disc : t2;
	let t3;
	let t4;
	if ($[2] !== nodeType) {
		t3 = (editor) => someList(editor, nodeType);
		t4 = [nodeType];
		$[2] = nodeType;
		$[3] = t3;
		$[4] = t4;
	} else {
		t3 = $[3];
		t4 = $[4];
	}
	const pressed = useEditorSelector(t3, t4);
	let t5;
	if ($[5] !== nodeType || $[6] !== pressed) {
		t5 = {
			nodeType,
			pressed
		};
		$[5] = nodeType;
		$[6] = pressed;
		$[7] = t5;
	} else t5 = $[7];
	return t5;
};
const useListToolbarButton = (t0) => {
	const $ = c(6);
	const { nodeType, pressed } = t0;
	const editor = useEditorRef();
	let t1;
	if ($[0] !== editor || $[1] !== nodeType) {
		t1 = () => {
			toggleList(editor, { listStyleType: nodeType });
		};
		$[0] = editor;
		$[1] = nodeType;
		$[2] = t1;
	} else t1 = $[2];
	let t2;
	if ($[3] !== pressed || $[4] !== t1) {
		t2 = { props: {
			pressed,
			onClick: t1,
			onMouseDown: _temp$1
		} };
		$[3] = pressed;
		$[4] = t1;
		$[5] = t2;
	} else t2 = $[5];
	return t2;
};
function _temp$1(e) {
	e.preventDefault();
}

//#endregion
//#region src/react/hooks/useTodoListElement.ts
const useTodoListElementState = (t0) => {
	const $ = c(5);
	const { element } = t0;
	const editor = useEditorRef();
	const { checked } = element;
	const readOnly = useReadOnly();
	let t1;
	if ($[0] !== checked || $[1] !== editor || $[2] !== element || $[3] !== readOnly) {
		t1 = {
			checked,
			editor,
			element,
			readOnly
		};
		$[0] = checked;
		$[1] = editor;
		$[2] = element;
		$[3] = readOnly;
		$[4] = t1;
	} else t1 = $[4];
	return t1;
};
const useTodoListElement = (state) => {
	const { checked, editor, element, readOnly } = state;
	return { checkboxProps: {
		checked: !!checked,
		onCheckedChange: (value) => {
			if (readOnly) return;
			const path = editor.api.findPath(element);
			if (!path) return;
			editor.tf.setNodes({ checked: value }, { at: path });
		},
		onMouseDown: (e) => {
			e.preventDefault();
		}
	} };
};

//#endregion
//#region src/react/hooks/useTodoListToolbarButton.ts
const useIndentTodoToolBarButtonState = (t0) => {
	const $ = c(7);
	let t1;
	if ($[0] !== t0) {
		t1 = t0 === void 0 ? {} : t0;
		$[0] = t0;
		$[1] = t1;
	} else t1 = $[1];
	const { nodeType: t2 } = t1;
	const nodeType = t2 === void 0 ? ListStyleType.Disc : t2;
	let t3;
	if ($[2] !== nodeType) {
		t3 = [nodeType];
		$[2] = nodeType;
		$[3] = t3;
	} else t3 = $[3];
	const pressed = useEditorSelector(_temp, t3);
	let t4;
	if ($[4] !== nodeType || $[5] !== pressed) {
		t4 = {
			nodeType,
			pressed
		};
		$[4] = nodeType;
		$[5] = pressed;
		$[6] = t4;
	} else t4 = $[6];
	return t4;
};
const useIndentTodoToolBarButton = (t0) => {
	const $ = c(6);
	const { nodeType, pressed } = t0;
	const editor = useEditorRef();
	let t1;
	if ($[0] !== editor || $[1] !== nodeType) {
		t1 = () => {
			toggleList(editor, { listStyleType: nodeType });
		};
		$[0] = editor;
		$[1] = nodeType;
		$[2] = t1;
	} else t1 = $[2];
	let t2;
	if ($[3] !== pressed || $[4] !== t1) {
		t2 = { props: {
			pressed,
			onClick: t1,
			onMouseDown: _temp2
		} };
		$[3] = pressed;
		$[4] = t1;
		$[5] = t2;
	} else t2 = $[5];
	return t2;
};
function _temp(editor) {
	return someTodoList(editor);
}
function _temp2(e) {
	e.preventDefault();
}

//#endregion
export { ListPlugin, useIndentTodoToolBarButton, useIndentTodoToolBarButtonState, useListToolbarButton, useListToolbarButtonState, useTodoListElement, useTodoListElementState };